export default "__VITE_ASSET__DUI7o_bu__"